import { Desktop } from '../../../common/packages/Responsive';
import { PageLayout } from '../../components/PageLayout';
import { BannersContainer } from '../BannersContainer';
import { ChatModalContainer } from '../ChatModalContainer';
import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend';
import { useFiltersUpdatedEvent } from '../DesktopFiltersMicrofrontend/hooks';
import { Map } from '../Map';
import { NavigationContainer } from '../Navigation';
import { Notifications } from '../Notifications';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { SidebarContainer } from '../SidebarContainer';

export function PageContainer() {
  useFiltersUpdatedEvent();

  return (
    <>
      <PageLayout
        navigation={
          <>
            <Desktop>
              <DesktopFiltersMicrofrontend />
            </Desktop>
            <NavigationContainer />
          </>
        }
        sidebar={
          <Desktop>
            <SidebarContainer />
          </Desktop>
        }
        map={<Map />}
      />
      <SaveSearchModalContainer />
      <Notifications />
      <BannersContainer />
      <ChatModalContainer />
    </>
  );
}
